import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-61122444")

_pushScopeId("data-v-61122444")
const _hoisted_1 = {
  key: 0,
  class: "\n        notification-card \n          bg-white text-12px xxl:text-14px w-auto z-30 border border-gray-lp-400 px-4 py-5 shadow-md rounded-md font-montserrat\n      "
}
const _hoisted_2 = { class: "flex gap-x-6 justify-between items-start" }
const _hoisted_3 = {
  class: "font-semibold text-black-lp-300",
  style: {"width":"20rem"}
}
const _hoisted_4 = { class: "font-normal mt-2" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = { class: "w-5/12" }
const _hoisted_7 = { class: "w-7/12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!

  return (_openBlock(), _createBlock(_Transition, { name: "notification" }, {
    default: _withId(() => [
      (_ctx.modelValue || (_ctx.modelValue && _ctx.data))
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_Icons, {
                name: _ctx.customIcon,
                class: _ctx.iconColor
              }, null, 8, ["name", "class"]),
              _createVNode("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(_ctx.message) + " ", 1),
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1),
                    _createVNode("div", _hoisted_7, ": " + _toDisplayString(_ctx.data.sttCommodityGroupName), 1)
                  ])
                ])
              ]),
              _createVNode("img", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
                src: _imports_0,
                class: "cursor-pointer",
                alt: "close-icon"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})